import styled from 'styled-components'
import React from 'react'

interface CircularProgressProps {
  percent?: number
  value?: number
  maxValue?: number
}

interface ProgressBarProps {
  percent?: number
  value?: number
  maxValue?: number
}

const ProgressWrapper = styled.div`
  position: relative;
  width: 24px;
  height: 24px;
`

const ProgressBar = styled.div<ProgressBarProps>`
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 2px solid #ccc;
  clip: rect(0, 24px, 24px, 12px);
  transform: rotate(-90deg);
  transform-origin: center center;
`

const ProgressIndicator = styled.div<ProgressBarProps>`
  position: absolute;
  top: 0;
  left: 50%;
  width: 12px;
  height: 12px;
  transform-origin: center center;
  border-radius: 50%;
  background-color: #007bff;
  clip: rect(0, 12px, 12px, 0);
  transform: ${(props) => `rotate(${(props.value! / props.maxValue!) * 360}deg)`};
`

const CircularProgress = ({ percent, value, maxValue = 100 }: CircularProgressProps) => {
  const progress = value ? value : percent ? maxValue * (percent / 100) : 0
  return (
    <ProgressWrapper>
      <ProgressBar value={progress} maxValue={maxValue} />
      <ProgressIndicator value={progress} maxValue={maxValue} />
    </ProgressWrapper>
  )
}

export default CircularProgress

interface IStyledPieProps {
  dataValue?: any
}

interface IPieProps
  extends IStyledPieProps,
    Omit<React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>, 'ref'> {}

const StyledPie = styled.div<IStyledPieProps>`
  .pie {
    --d: 20px;
    --color: ${(props) =>
      props.dataValue >= 80
        ? `${props.theme.colors.success.neutral}`
        : props.dataValue >= 40
        ? `${props.theme.colors.info.neutral}`
        : `${props.theme.colors.error.neutral}`};
    --progress: ${(props) => props.dataValue};
    background-color: ${(props) =>
      props.dataValue >= 80
        ? `${props.theme.colors.success.lighter}`
        : props.dataValue >= 40
        ? `${props.theme.colors.info.lighter}`
        : `${props.theme.colors.error.lighter}`};
    border-radius: var(--d);
    height: var(--d);
    width: var(--d);
    background-image: conic-gradient(
      var(--color) calc(calc(var(--progress) / 100) * 360deg),
      transparent calc(calc(var(--progress) / 100) * 360deg)
    );
  }
`

export const Pie = ({ dataValue }: IPieProps) => {
  return (
    <StyledPie dataValue={dataValue}>
      <div className="pie"></div>
    </StyledPie>
  )
}
